/**
 * @prettier
 */

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
import "firebase/functions";

(window as any).firebase = firebase;

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDERID,
  appId: process.env.REACT_APP_APPID,
  measurementId: process.env.REACT_APP_MEASUREMENTID,
};

// Initialize Firebase app
let firebaseApp;
if (!firebase.apps.length) {
  console.log("Firebase initialized");
  firebaseApp = firebase.initializeApp(firebaseConfig);
}

const auth = firebaseApp.auth();
const firestore = firebaseApp.firestore();
const storage = firebaseApp.storage();

// Optionally configure Cloud Functions
const functions = firebaseApp.functions();

// Enable offline persistence — except on Safari. Safari's IndexedDB plus
// this SDK's (7.14.2) multi-tab persistence is a known-broken combination:
// Firestore wedges into an offline state and every read fails instantly
// while Auth keeps working, which staff saw as a screen-flash loop
// (2026-08-14). Persistence is only an offline cache; Safari does without.
const isSafari = /^((?!chrome|android|crios|fxios|edg).)*safari/i.test(
  navigator.userAgent
);
if (!isSafari) {
  firestore.enablePersistence({ synchronizeTabs: true }).catch((err) => {
    if (err.code === "failed-precondition") {
      console.error("Persistence failed: Multiple tabs open.");
    } else if (err.code === "unimplemented") {
      console.error("Persistence is not available in this browser.");
    }
  });
}

export { firebase, auth, firestore, storage, functions };
